import { connect } from 'react-redux';
import { get } from 'lodash';
import HeaderLogin from './header-login.component';

const mapStateToProps = (state: Object) => ({
    config: get(state, 'config'),
    activeLanguageCode: get(state, 'language.activeLanguageCode'),
});

export default connect(mapStateToProps)(HeaderLogin);
